import { api } from "../utils/api";
import type {
  RestCourse,
  RestCreateCourse,
  RestUpdateCourse,
} from "@KassaroAB/shared/types/course";
import type { CourseId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const coursesPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "courses");

export const getCoursesApi = (scope: CatalogScope): Promise<RestCourse[]> => {
  return api.get(coursesPath(scope));
};

export const getCourseApi = (
  scope: CatalogScope,
  courseId: CourseId,
): Promise<RestCourse> => {
  return api.get(`${coursesPath(scope)}/${courseId}`);
};

export const createCourseApi = (
  scope: CatalogScope,
  course: RestCreateCourse,
): Promise<RestCourse> => {
  return api.post(coursesPath(scope), course);
};

export const updateCourseApi = (
  scope: CatalogScope,
  courseId: CourseId,
  course: RestUpdateCourse,
): Promise<RestCourse> => {
  return api.put(`${coursesPath(scope)}/${courseId}`, course);
};

export const deleteCourseApi = (
  scope: CatalogScope,
  courseId: CourseId,
): Promise<void> => {
  return api.delete(`${coursesPath(scope)}/${courseId}`);
};
